import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Tabs, Tab } from "@mui/material";

const Navigation = () => {
  const location = useLocation();

  const handleChange = (event, newValue) => {
    // Handle tab change if needed
  };

  const links = [
    {
      label: "Home",
      to: "/",
    },
    {
      label: "Transitions",
      to: "/transitions",
    },
    {
      label: "Compare",
      to: "/compare",
    },
    {
      label: "Citation",
      to: "/citation",
    },
  ];

  return (
    <Tabs
      value={location.pathname}
      onChange={handleChange}
      indicatorColor="primary"
      textColor="primary"
      centered>
      {links.map((link, index) => (
        <Tab
          key={index}
          label={link.label}
          component={Link}
          to={link.to}
          value={link.to}
        />
      ))}
    </Tabs>
  );
};

export default Navigation;
